var map = {
	"./de/mecha-btn.png": "In3E",
	"./en/mecha-btn.png": "aPLZ",
	"./es/mecha-btn.png": "Bmw3",
	"./fr/mecha-btn.png": "XNGo",
	"./ja/mecha-btn.png": "KUTo",
	"./ko/mecha-btn.png": "jKJJ",
	"./pt/mecha-btn.png": "KL89",
	"./ru/mecha-btn.png": "2Ebz",
	"./tc/mecha-btn.png": "aLRU",
	"./th/mecha-btn.png": "Hlew"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XOj6";